class ProductBuyBar extends HTMLElement {
  constructor() {
    "use strict";
    super();

    let classes = { show: "show" };
    let mainProductForm = document.querySelector(".product-form");
    const showFromStart = () => this.dataset.available === "true" && window.matchMedia("(max-width: 767px)").matches;

    // SF: the bar hides while the main form or the footer is in view, and shows otherwise.
    // On mobile the bottom 70px (the bar itself) do not count as "in view".
    let formInView = false;
    let footerInView = false;
    const update = () => {
      if (formInView || footerInView) {
        this.classList.remove(classes.show);
      } else if (window.scrollY > 200 || showFromStart()) {
        this.classList.add(classes.show);
      }
    };
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target === mainProductForm) {
            formInView = entry.isIntersecting;
          } else {
            footerInView = entry.isIntersecting;
          }
        });
        update();
      },
      { threshold: 0.25, rootMargin: showFromStart() ? "0px 0px -70px 0px" : "0px" }
    );

    observer.observe(mainProductForm);

    // This script is loaded in product-template.liquid --> Footer observer after DOM ready
    document.addEventListener("DOMContentLoaded", function () {
      let siteFooter = document.querySelector("footer.footer");
      if (!siteFooter) return;
      observer.observe(siteFooter);
    });
  }
}
customElements.define("product-buy-bar", ProductBuyBar);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.image = this.querySelector('.card-media img');

    if (this.select) {
      this.select.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute('data-variant-img-src');
        if (newImgSrc) { this.updateImage(newImgSrc) }
      });
    }
  }

  updateImage(newImgSrc) {
    if (this.image) {
      this.image.src = newImgSrc;
    }
  }
}

customElements.define('upsell-card', UpsellCard);